<div class="container">
  <div class="loading-overlay" *ngIf="(claimSearchState$ | async)?.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <section class="form-container">
    <div class="form-container__controls" [formGroup]="form">
      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label [for]="dateOfServiceInput" text="Date of Service">
          </kendo-label>
          <kendo-datepicker
            #dateOfServiceInput
            class="form-field"
            formControlName="dateOfService"
            placeholder=""
          ></kendo-datepicker>
        </kendo-formfield>
      </div>

      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label
            [for]="serviceProviderIdentifierQualifierInput"
            text="Service Provider Identifier Qualifier"
          >
          </kendo-label>
          <kendo-combobox
            #serviceProviderIdentifierQualifierInput
            class="form-field"
            [data]="idQualifierOptions"
            formControlName="serviceProviderIdentifierQualifier"
            [valuePrimitive]="true"
            textField="text"
            valueField="value"
            [filterable]="false"
            [clearButton]="false"
            [popupSettings]="{ width: 'auto' }"
          ></kendo-combobox>
        </kendo-formfield>
      </div>

      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label
            [for]="serviceProviderIdentifierInput"
            text="Service Provider Identifier"
          >
          </kendo-label>
          <kendo-textbox
            #serviceProviderIdentifierInput
            class="form-field"
            formControlName="serviceProviderIdentifier"
            [maxlength]="10"
          >
          </kendo-textbox>
        </kendo-formfield>
      </div>

      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label
            [for]="prescriptionServiceReferenceNumberInput"
            text="Prescription/Service Reference Number"
          >
          </kendo-label>
          <kendo-textbox
            #prescriptionServiceReferenceNumberInput
            class="form-field"
            formControlName="prescriptionServiceReferenceNumber"
            [maxlength]="100"
          >
          </kendo-textbox>
        </kendo-formfield>
      </div>

      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label [for]="fillNumberInput" text="Fill Number">
          </kendo-label>
          <kendo-textbox
            #fillNumberInput
            class="form-field"
            formControlName="fillNumber"
            [maxlength]="10"
          >
          </kendo-textbox>
        </kendo-formfield>
      </div>

      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label [for]="ndcInput" text="NDC"> </kendo-label>
          <kendo-textbox
            #ndcInput
            class="form-field"
            formControlName="ndc"
            [maxlength]="11"
          >
          </kendo-textbox>
        </kendo-formfield>
      </div>
    </div>
    <div class="form-container__btns">
      <button
        kendoButton
        [primary]="true"
        [disabled]="
          form.pristine ||
          form.invalid ||
          !!(claimSearchState$ | async)?.pending
        "
        (click)="submitSearch()"
      >
        <span class="k-icon k-font-icon k-i-search"></span>
        Search
      </button>
    </div>
  </section>

  <ng-container *ngIf="!!(claimSearchState$ | async)?.data">
    <ng-container *ngIf="claimSearchState$ | async as result">
      <section class="result-container">
        <div class="result-field">
          <kendo-label class="result-field__label" text="Claim Found">
          </kendo-label>
          <div class="result-field__textbox">
            <span>{{ result.data?.isFound | booleanYesNo }}</span>
          </div>
        </div>

        <div class="result-field">
          <kendo-label class="result-field__label" text="Claim Status">
          </kendo-label>
          <div class="result-field__textbox">
            <span>{{ result.data?.status }}</span>
          </div>
        </div>

        <div class="result-field">
          <kendo-label class="result-field__label" text="CE ID"> </kendo-label>
          <div class="result-field__textbox">
            <span>{{ result.data?.ceId }}</span>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
</div>
